module.exports = __webpack_public_path__ + "static/media/confluence.b4295764.svg";